import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseCallQueueParticipant } from 'entities/Call'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallPopUpGlobalStore } from 'widgets/CallPopUp'

export const useEventCallQueueParticipantLeave = (callPopUpGlobalStore: CallPopUpGlobalStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseCallQueueParticipant) => {
    callPopUpGlobalStore.deleteItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallQueueParticipantLeave, handler), [])
}
